
import { useState, useCallback, useRef, useEffect } from 'react'
import { CloseOutlined } from '@ant-design/icons'
import { generateCustomerAccountCode } from '@/utils/customerAccountAuth';
import {getUserInfo} from '@/utils/common'
import styles from '../style.module.less'

const DRAG_THRESHOLD = 5
const LONG_PRESS_MS = 300

type MenuPosition = { left: number; top: number }

const clampMenuPosition = (left: number, top: number, el: HTMLElement | null): MenuPosition => {
    const width = el?.offsetWidth ?? 70
    const height = el?.offsetHeight ?? 70
    const maxLeft = Math.max(0, window.innerWidth - width)
    const maxTop = Math.max(0, window.innerHeight - height)
    return {
        left: Math.min(Math.max(0, left), maxLeft),
        top: Math.min(Math.max(0, top), maxTop),
    }
}

const Index = () => {
    const [aiVisible, setAiVisible] = useState(false)
    const [aiUrl, setAiUrl] = useState('')
    const [position, setPosition] = useState<MenuPosition | null>(null)
    const rootRef = useRef<HTMLDivElement>(null)
    const skipClickRef = useRef(false)

    useEffect(() => {
        const onResize = () => {
            setPosition((prev) => (prev ? clampMenuPosition(prev.left, prev.top, rootRef.current) : prev))
        }
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    }, [])

    const handleAiMenu = useCallback(async () => {
        const userInfo = getUserInfo()
        const CUSTOMER_ACCOUNT_SECRET_KEY = '16e6c3b4-abdd-4c2d-9634-cac15ef5f7c7';
        const Timestamp = Math.floor(Date.now() / 1000);
        // const CustomerId = '0001000628';
        const CustomerId = userInfo.jxsxx.partner || '';
        // const Name = '杭州雷超机电设备有限公司' || '';
        const Name = userInfo.jxsxx.jxsmc || '';
        const ExtraInfo = '';
        const code = await generateCustomerAccountCode(
        CUSTOMER_ACCOUNT_SECRET_KEY,
        CustomerId,
        Name,
        ExtraInfo,
        Timestamp,
        );
        const url =
        `https://ai-nmznt.dongcheng.com/account/customer?CustomerId=${encodeURIComponent(CustomerId)}`
        + `&Name=${encodeURIComponent(Name)}`
        + `&Timestamp=${Timestamp}`
        + `&ExtraInfo=${encodeURIComponent(ExtraInfo)}`
        + `&Code=${encodeURIComponent(code)}`;
        // setAiUrl(url);
        // setAiVisible(true);
        window.open(url, '_blank')
    }, []);

    const handleAiClose = useCallback(() => {
        setAiVisible(false)
    }, [])

    const handleBtnPointerDown = useCallback((e: React.PointerEvent<HTMLDivElement>) => {
        if (e.button !== 0) return
        const target = e.currentTarget
        const root = rootRef.current
        if (!root) return

        let startLeft: number
        let startTop: number
        if (position) {
            startLeft = position.left
            startTop = position.top
        } else {
            const rect = root.getBoundingClientRect()
            startLeft = rect.left
            startTop = rect.top
            setPosition({ left: startLeft, top: startTop })
        }

        const startX = e.clientX
        const startY = e.clientY
        const pressStartTime = Date.now()
        let moved = false

        target.setPointerCapture(e.pointerId)

        const onPointerMove = (ev: PointerEvent) => {
            const dx = ev.clientX - startX
            const dy = ev.clientY - startY
            if (!moved && (Math.abs(dx) > DRAG_THRESHOLD || Math.abs(dy) > DRAG_THRESHOLD)) {
                moved = true
            }
            if (!moved) return
            const next = clampMenuPosition(startLeft + dx, startTop + dy, root)
            setPosition(next)
        }

        const onPointerUp = (ev: PointerEvent) => {
            target.releasePointerCapture(ev.pointerId)
            window.removeEventListener('pointermove', onPointerMove)
            window.removeEventListener('pointerup', onPointerUp)
            window.removeEventListener('pointercancel', onPointerUp)
            const heldTooLong = Date.now() - pressStartTime > LONG_PRESS_MS
            if (moved || heldTooLong) {
                skipClickRef.current = true
            }
            if (moved) {
                setPosition((prev) => (prev ? clampMenuPosition(prev.left, prev.top, root) : prev))
            }
        }

        window.addEventListener('pointermove', onPointerMove)
        window.addEventListener('pointerup', onPointerUp)
        window.addEventListener('pointercancel', onPointerUp)
    }, [position])

    const handleBtnClick = useCallback(() => {
        if (skipClickRef.current) {
            skipClickRef.current = false
            return
        }
        handleAiMenu()
    }, [handleAiMenu])

    const menuStyle = position
        ? { left: position.left, top: position.top, right: 'auto', bottom: 'auto' as const }
        : undefined

    return (
        <>
            <div
                ref={rootRef}
                className={`${styles['ai-menu']} ${position ? styles['ai-menu-positioned'] : ''}`}
                style={menuStyle}
            >
                <div
                    className={styles['ai-menu-btn']}
                    onPointerDown={handleBtnPointerDown}
                    onClick={handleBtnClick}
                />
                <div className={`${styles['ai-menu-container']} ${aiVisible && styles.visible}`}>
                    <div className={styles['ai-menu-close']} onClick={handleAiClose}>
                        <CloseOutlined />
                    </div>
                    <iframe src={aiUrl} width="100%" height="100%" frameBorder="none" />
                </div>
            </div>

        </>
    )
}

export default Index
